(() => {
  const hydrate = (card) => {
    if (!card) return;
    card.querySelectorAll('img[data-sb-gallery-image]').forEach((image) => {
      if (image.dataset.sbSrcset) image.srcset = image.dataset.sbSrcset;
      if (image.dataset.sbSrc) image.src = image.dataset.sbSrc;
      image.removeAttribute('data-sb-gallery-image');
      image.removeAttribute('data-sb-srcset');
      image.removeAttribute('data-sb-src');
    });
  };
  ['pointerover', 'pointerdown', 'focusin', 'touchstart'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      hydrate(event.target.closest('product-card, .product_card_wrapper'));
    }, {capture: true, passive: true});
  });
  const footer = document.querySelector('[data-sb-footer-image]');
  if (footer) {
    const footerObserver = new IntersectionObserver((entries, observer) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      footer.style.setProperty('--sb-footer-image', `url("${footer.dataset.sbFooterImage}")`);
      observer.disconnect();
    }, {rootMargin: '600px'});
    footerObserver.observe(footer);
  }
  const titleFrame = (frame) => {
    if (frame.title || frame.getAttribute('aria-hidden') === 'true') return;
    const source = frame.getAttribute('src') || '';
    if (frame.id === 'merchantwidgetiframe' || source.includes('google.com/shopping/merchantverse')) {
      frame.title = 'Google store reviews';
    } else if (/shopify|shop\.app/.test(source)) {
      frame.title = 'Shopify shopping services';
    }
  };
  document.querySelectorAll('iframe').forEach(titleFrame);
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches('iframe')) titleFrame(node);
        node.querySelectorAll('iframe').forEach(titleFrame);
      }
    }
  });
  observer.observe(document.body, {childList: true, subtree: true});
})();
